<!-- TBD / TODO: try to implement clean link / click event solution across all cards (?!) -->
@if (link) {
  @switch (link.type) {
    @case (linkTypes.ROUTER) {
      <a class="card-container" [routerLink]="link.url">
        <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
      </a>
    }
    @case (linkTypes.PROGRAMMATIC) {
      <a class="card-container" (click)="linkAction($event)">
        <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
      </a>
    }
    @case (linkTypes.EXTERNAL) {
      <a class="card-container" [href]="link.url" [target]="link.target">
        <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
      </a>
    }
    @case (linkTypes.NONE) {
      <div class="card-container">
        <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
      </div>
    }
  }
} @else {
  <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
}

<ng-template #cardTemplate>
  <wb-card [attr.variant]="darkTheme ? 'dark-grey' : null" interactive>
    <figure>
      <div class="topline">
        <div class="event-status">
          @switch (eventState) {
            @case (eventStates.UPCOMING) {
              <mb-small-spinner></mb-small-spinner>
              @if (distance) {
                <wb-text size="s">
                  {{ 'EVENT_CARD_STARTS_IN' | translate: { distance: distance } }}
                </wb-text>
              }
            }

            @case (eventStates.RUNNING) {
              <mb-live-indicator></mb-live-indicator>
              <wb-text size="s">{{ 'EVENT_CARD_RUNNING' | translate }}</wb-text>
            }
          }
        </div>

        <div class="topline-right">
          @if (attendanceStatus) {
            <span [class]="'mb-icon ' + attendancesToIconMap[attendanceStatus]"></span>
          }
          @if (isArchived) {
            <wb-tag [variant]="darkTheme ? 'secondary' : 'tertiary'" theme="light">
              {{ 'ARCHIVED_CONTENT' | translate }}
            </wb-tag>
          }
        </div>
      </div>

      @if (image && !showImageFallback) {
        <mb-media [media]="image" [hoverplay]="true" (imageError)="showImageFallback = true"></mb-media>
      }
      @if (!image || showImageFallback) {
        <img src="assets/img/fallbacks/Mercedes-Benz_4_3_800.png" />
      }
    </figure>

    <div class="card-content">
      <div class="content-text">
        @if (titleHash) {
          <wb-text size="m"> {{ titleHash }} </wb-text>
        }
        @if (headline) {
          <wb-heading size="xs">{{ headline }}</wb-heading>
        }
        @if (startDate && endDate) {
          <time [attr.start]="startDate" [attr.end]="endDate">
            <wb-text size="m">{{ startDate | timePeriod: endDate : timezoneOffset }}</wb-text>
          </time>
        }
        @if (registrationDeadline && isPending()) {
          <wb-text size="m" class="registration-deadline">
            {{
              'EVENT_RIBBON_CARD_EMBARGO_UNTIL' | translate: { date: registrationDeadline | localizedDate: 'longDate' }
            }}
          </wb-text>
        }
      </div>
      @if (location) {
        <div class="location">
          <wb-icon name="bds/location/24"></wb-icon>
          <wb-text tag="p" size="s" class="location-text" static> {{ location }} </wb-text>
        </div>
      }
    </div>
  </wb-card>
</ng-template>
